import advupLabs from './advupLabs.json';
import aiSummary from './aiSummary.json';
import livroDeToques from './livroDeToques.json';
import avisosAoCliente from './avisosAoCliente.json';
import textoComVariaveis from './textoComVariaveis.json';
import regrasDeEnvio from './regrasDeEnvio.json';
import pendencias from './pendencias.json';
import perguntasSobreProcesso from './perguntasSobreProcesso.json';
import appointments from './appointments.json';
import broadcasts from './broadcasts.json';
import internalChats from './internalChats.json';
import commercialAnalysis from './commercialAnalysis.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contentTemplates from './contentTemplates.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import followUps from './followUps.json';
import systemHealth from './systemHealth.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import leadScore from './leadScore.json';
import login from './login.json';
import macros from './macros.json';
import mfa from './mfa.json';
import pipeline from './pipeline.json';
import pipelineWebhooks from './pipelineWebhooks.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import webhooks from './webhooks.json';
import whatsappTemplates from './whatsappTemplates.json';
import telefonia from './telefonia.json';
import integracoesDoEscritorio from './integracoesDoEscritorio.json';
import whitelabel from './whitelabel.json';
import yearInReview from './yearInReview.json';
import lumos from './lumos.json';
import legalModule from './legalModule.json';
import legalClientModule from './legalClientModule.json';
import contactRecords from './contactRecords.json';
import financialModule from './financialModule.json';
import correio from './correio.json';
import assinaturas from './assinaturas.json';
import minutas from './minutas.json';
import buscaGlobal from './buscaGlobal.json';

export default {
  ...legalModule,
  ...buscaGlobal,
  ...contactRecords,
  ...legalClientModule,
  ...financialModule,
  ...correio,
  ...assinaturas,
  ...minutas,
  ...appointments,
  ...broadcasts,
  ...internalChats,
  ...commercialAnalysis,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...contentTemplates,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...followUps,
  ...systemHealth,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...leadScore,
  ...login,
  ...macros,
  ...mfa,
  ...advupLabs,
  ...pipeline,
  ...pipelineWebhooks,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...webhooks,
  ...whatsappTemplates,
  ...telefonia,
  ...integracoesDoEscritorio,
  ...whitelabel,
  ...yearInReview,
  ...lumos,
  ...aiSummary,
  ...livroDeToques,
  ...avisosAoCliente,
  ...textoComVariaveis,
  ...regrasDeEnvio,
  ...pendencias,
  ...perguntasSobreProcesso,
};
